// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Record from "../Record/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var modify = /* #__PURE__ */ Specular_Ref.modify(Effect_Class.monadEffectEffect);
var switchRecordNil = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        switchRecord: function (v) {
            return function (v1) {
                return to({});
            };
        }
    };
};
var switchRecord = function (dict) {
    return dict.switchRecord;
};
var switchRecordI = function (dictSwitchRecord) {
    var switchRecord1 = switchRecord(dictSwitchRecord);
    return function () {
        return {
            "switch": switchRecord1(Type_Proxy["Proxy"].value)
        };
    };
};
var switchEvent = {
    "switch": Specular_FRP_Base["switch"]
};
var switchEffect = {
    "switch": /* #__PURE__ */ (function () {
        var $43 = Control_Bind.join(Effect.bindEffect);
        var $44 = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
        return function ($45) {
            return $43($44($45));
        };
    })()
};
var switchDynamic = {
    "switch": /* #__PURE__ */ Control_Bind.join(Specular_FRP_Base.bindDynamic)
};
var $$switch = function (dict) {
    return dict["switch"];
};
var switch1 = /* #__PURE__ */ $$switch(switchDynamic);
var switchFunction = function (dictSwitch) {
    var switch3 = $$switch(dictSwitch);
    return {
        "switch": function (f) {
            return function (x) {
                return switch3(map(function (v) {
                    return v(x);
                })(f));
            };
        }
    };
};
var switch2 = /* #__PURE__ */ $$switch(/* #__PURE__ */ switchFunction(switchEffect));
var switchRecordCons = function (dictIsSymbol) {
    var insert = Record.insert(dictIsSymbol)()();
    var get = Record.get(dictIsSymbol)();
    return function () {
        return function () {
            return function (dictSwitch) {
                var switch3 = $$switch(dictSwitch);
                return function (dictSwitchRecord) {
                    var switchRecord1 = switchRecord(dictSwitchRecord);
                    return function () {
                        return {
                            switchRecord: function (v) {
                                return function (dyn) {
                                    return insert(Type_Proxy["Proxy"].value)(switch3(map(get(Type_Proxy["Proxy"].value))(dyn)))(switchRecord1(Type_Proxy["Proxy"].value)(dyn));
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var switchRef = {
    "switch": function (dyn) {
        return new Specular_Ref.Ref(switch1(map(Specular_Ref.value)(dyn)), switch2(map(modify)(dyn)));
    }
};
var dynamicSwitch = function (dictSwitch) {
    var switch3 = $$switch(dictSwitch);
    return function (dictMonadReplace) {
        var dynamic = Specular_FRP_Replaceable.dynamic(dictMonadReplace);
        return function (dictMonadFRP) {
            var $46 = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(switch3);
            var $47 = dynamic(dictMonadFRP);
            return function ($48) {
                return $46($47($48));
            };
        };
    };
};
export {
    $$switch as switch,
    dynamicSwitch,
    switchRecord,
    switchDynamic,
    switchEvent,
    switchEffect,
    switchFunction,
    switchRef,
    switchRecordI,
    switchRecordNil,
    switchRecordCons
};
